import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ControlValidatorModule } from '@directives';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMaskModule } from 'ngx-mask';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { ChooseDepartmentComponent } from './choose-department/choose-department.component';
import { NotFoundPropertiesComponent } from './not-found-properties/not-found-properties.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { RequestVisitComponent } from './request-visit/request-visit.component';
import { ScheduleVisitRoutingModule } from './schedule-visit-routing.module';
import { ScheduleVisitComponent } from './schedule-visit.component';
import { SelectDatetimeComponent } from './select-datetime/select-datetime.component';

@NgModule({
  declarations: [
    ScheduleVisitComponent,
    NotFoundPropertiesComponent,
    ChooseDepartmentComponent,
    SelectDatetimeComponent,
    PreferencesComponent,
    RequestVisitComponent,
    BookingSummaryComponent,
  ],
  imports: [
    CommonModule,
    ScheduleVisitRoutingModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgxDaterangepickerMd.forRoot(),
    FormsModule,
    NgxMaskModule.forRoot(),
    ControlValidatorModule,
  ],
})
export class ScheduleVisitModule {}
